import Axios from "axios";
const auth0Authorization = Axios.create({
  baseURL: "https://" + window._env_.REACT_APP_AUTH0_DOMAIN + "/oauth",
});

auth0Authorization.interceptors.request.use(
  (config) => {
    return config;
  },
  async (error) => {
    return await Promise.reject(error);
  },
);

auth0Authorization.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if ([401, 403].includes(error.response?.status)) {
      // window.unauthorize_modal.showModal();
    }
    return await Promise.reject(error);
  },
);

export default auth0Authorization;
